import { Routes } from '@angular/router';

import { routes as dashboardRoutes } from './pages/dashboard-v2/dashboard-routes';
import { routes as profileRoutes } from './pages/profile-v2/routes';
import { routes as myForestRoutes } from './pages/my-forest/my-forest.routes';
import { routes as myReferralsRoutes } from './pages/my-referrals/my-referrals.routes';
import { routes as balanceRoutes } from './pages/balance/routes';
import { routes as rewardsRoutes } from './pages/rewards/routes';
import { routes as promotionsRoutes } from './pages/promotions/routes';
import { routes as okeeCashRoutes } from './pages/okeey-cash/okeey-cash.module';
import { FaqComponent } from './pages/faq/faq.component';
import { onlyUsMemberGuard } from 'core';

export const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full', data: { breadcrumb: null } },
  {
    path: 'dashboard',
    data: { breadcrumb: 'leftSidebar.dashboard' },
    children: dashboardRoutes
  },
  {
    path: 'profile',
    data: { breadcrumb: 'leftSidebar.settings' },
    children: profileRoutes
  },
  {
    path: 'my-forest',
    data: { breadcrumb: 'my-forest.my-forest' },
    children: myForestRoutes
  },
  {
    path: 'my-referrals',
    data: { breadcrumb: 'leftSidebar.buildYourNetwork' },
    children: myReferralsRoutes
  },
  {
    path: 'balance',
    data: { breadcrumb: 'balance.accountBalance' },
    children: balanceRoutes
  },
  {
    path: 'rewards',
    data: { breadcrumb: 'leftSidebar.rewards' },
    children: rewardsRoutes
  },
  {
    path: 'promotions',
    data: { breadcrumb: 'promotions.breadcrumbForYou', title: 'promotions.title' },
    children: promotionsRoutes
  },
  {
    path: 'faq',
    data: { breadcrumb: 'leftSidebar.helpSupport' },
    children: [{ path: '', component: FaqComponent }]
  },
  {
    path: 'my-okeey-cash',
    data: { breadcrumb: 'leftSidebar.myOkeeyCash' },
    canActivate: [onlyUsMemberGuard],
    children: okeeCashRoutes
  }
];
